import { ImageStyle, Platform, PlatformOSType, StyleSheet, TextStyle, ViewStyle } from 'react-native';

interface WebSpecificStyles {
    cursor?: string,
    outlineColor?: string,
    outlineOffset?: number | string,
    outlineStyle?: string,
    outlineWidth?: number | string,
};


type TSpecifyType = 'view' | 'text' | 'image' | undefined;
type TStyle<ST extends TSpecifyType> = (ST extends 'view' ? ViewStyle : ST extends 'text' ? TextStyle : ST extends 'image' ? ImageStyle : (ViewStyle | TextStyle | ImageStyle)) & WebSpecificStyles;

/**
 * This function is similar to Platform.select with some extra stuff and added support for Typescript validation for styles.
 * @param specifics array of styles that are specific to a platform. Accepted platforms are all the PlatformOSType values and 'mobile'.
 * @param _specifyType Optional type if you need to specify the type of style you are passing in and want to get the correct type back.
 * Helpful for when you want to specify specific style you want returned like TextStyle, ViewStyle and so on.
 * @returns Styles object
 */
const mbPlatformStyle = <ST extends TSpecifyType>(specifics: { [platform in PlatformOSType | 'mobile']?: TStyle<ST> }, _specifyType?: ST): TStyle<ST> => {
    if (specifics.mobile) {
        if (Platform.OS === 'android' || Platform.OS === 'ios') {
            return StyleSheet.flatten([specifics.mobile, specifics[Platform.OS]]) as TStyle<ST>;
        }
    }

    return specifics[Platform.OS] ?? ({} as TStyle<ST>);
};

export { mbPlatformStyle };
